export default {
  mapApiKey: 'AIzaSyC6oxU7USYekoZPp2cvk_Fcw5jBSCSeei8',//'AIzaSyDtGae79QCyLcguBb2dqKbbgzcfzdU6Ntw',
  elasticApiKey: `6fbc05b6-ccf8-4a3b-9451-ec6ef3b4ff5d`,
};
